import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { FaqAccordion } from "../components/FaqAccordion";
import { SITE } from "../data/site";

export default function FaqPage() {
  return (
    <div data-testid="faq-page">
      <PageHero
        eyebrow="FAQ"
        title="Yang sering ditanyakan antrean."
        description="Jawaban singkat untuk pertanyaan paling sering muncul — dari apa itu ayam goreng basah sampai cara memesan tanpa antre."
        crumbs={[
          { label: "Beranda", href: "/" },
          { label: "FAQ", href: "/faq/" },
        ]}
      />

      <section className="mx-auto max-w-4xl px-5 py-14 sm:py-20" aria-label="Daftar pertanyaan">
        <FaqAccordion />

        <div className="mt-14 rounded-lg border-2 border-dashed border-bumbu/50 bg-bumbu-light/40 p-8 text-center">
          <h2 className="font-heading text-xl font-extrabold tracking-tight text-charcoal sm:text-2xl">
            Pertanyaanmu belum terjawab?
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-charcoal-muted sm:text-base">
            Sapa kami lewat pesan langsung di Instagram, atau lihat menu dan
            outlet kami lebih dulu.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-instagram-button"
              className="inline-flex items-center gap-2 rounded-full bg-charcoal px-7 py-3 font-heading text-sm font-bold text-canvas transition-all hover:scale-[1.03] hover:bg-bumbu hover:text-charcoal active:scale-[0.98]"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
              DM {SITE.instagramHandle}
            </a>
            <Link
              to="/menu/"
              data-testid="faq-menu-button"
              className="rounded-full border-2 border-charcoal px-7 py-3 font-heading text-sm font-bold text-charcoal transition-all hover:scale-[1.03] hover:bg-bumbu-light active:scale-[0.98]"
            >
              Lihat Menu
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
